let globalEnv = {
  development: {
    AJAX_SLIDE_URL: "/ajax-slide",
    AJAX_GET_OPENCAMPUS_URL: "/ajax_get_opencampus",
    SUBSCRIBE_EVENT_URL: "/api/opencampus/subscribe-event/",
  },
  production: {
    AJAX_SLIDE_URL: "/ajax-slide",
    AJAX_GET_OPENCAMPUS_URL: "/ajax_get_opencampus",
    SUBSCRIBE_EVENT_URL: [
      'https://www.tohogakuen.ac.jp.k.agn.hp.transer.com',
      'https://www.tohogakuen.ac.jp.t.agn.hp.transer.com',
      'https://www.tohogakuen.ac.jp.c.agn.hp.transer.com',
      'https://www.tohogakuen.ac.jp.f.agn.hp.transer.com',
      'https://www.tohogakuen.ac.jp.s.agn.hp.transer.com',
      'https://www.tohogakuen.ac.jp.e.agn.hp.transer.com',
      'https://www.tohogakuen.ac.jp.id.agn.hp.transer.com',
      'https://www.tohogakuen.ac.jp.th.agn.hp.transer.com',
      'https://www.tohogakuen.ac.jp.v.agn.hp.transer.com'
    ].indexOf(window.location.origin) > -1 ? "https://www.tohogakuen.ac.jp/api/opencampus/subscribe-event/" : "/api/opencampus/subscribe-event/",
  }
}

export default function env(property) {
  return globalEnv[process.env.NODE_ENV][property];
}
